import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { FrtShipmentPackagesEntity } from 'src/app/shared/common-components/common-structure';
import { catchError, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FrtShipmentPackageService extends DataService {

  private baseURI = this.apiUri + '/frtshipmentpackages/';
  private weightFromBookShipment = new BehaviorSubject<number>(null);
  private cubicFromBookShipment = new BehaviorSubject<number>(null);
  private fleetVehiclesFromBookShipment = new BehaviorSubject<number>(null);
  private sroIDFromBookShipment = new BehaviorSubject<string>(null); 
  private vehicleTypeFromBookShipment = new BehaviorSubject<string>(null);
  estimatedWeight = this.weightFromBookShipment.asObservable().pipe(distinctUntilChanged());
  estimatedCubic = this.cubicFromBookShipment.asObservable().pipe(distinctUntilChanged());
  noOfFleetVehicles = this.fleetVehiclesFromBookShipment.asObservable().pipe(distinctUntilChanged());
  fleetVehicleClass = this.vehicleTypeFromBookShipment.asObservable().pipe(distinctUntilChanged());
  sroID = this.sroIDFromBookShipment.asObservable().pipe(distinctUntilChanged());

  constructor(http: HttpClient) {
    super(http);
  }

  // get List of ShipmentPackagesDetails By ShipmentDetailsId
  getShipmentPackagesByShipmentDetailsId(frtShipmentDetailsId: number): Observable<FrtShipmentPackagesEntity[]> {
    this.setUri(this.baseURI + frtShipmentDetailsId + '/frtshipmentdetailsid');
    return this.get().pipe(catchError(this.handleError));
  }

  getShipmentPackagesByShipmentPackagesId(frtShipmentPackagesId: number): Observable<FrtShipmentPackagesEntity[]> {
    this.setUri(this.baseURI + frtShipmentPackagesId + '/frtShipmentPackagesId');
    return this.get().pipe(catchError(this.handleError));
  }

  saveShipmentPackageEntity(frtShipmentPackagesEntity: FrtShipmentPackagesEntity): Observable<any> {
    return this.http.post(this.baseURI + 'save', frtShipmentPackagesEntity);
  }

  updateShipmentPackageEntity(frtShipmentPackagesEntity: FrtShipmentPackagesEntity): Observable<any> {
    return this.http.put(this.baseURI + 'update', frtShipmentPackagesEntity);
  }

  deleteShipmentPackageEntity(frtShipmentPackagesId: number) {
    const Uri = this.baseURI + 'deletefrtshipmentpackage/' + frtShipmentPackagesId + '/frtShipmentPackagesId';
    return this.http.put(Uri, frtShipmentPackagesId);
  }

  setEstimatedWeightFromBookShipment(estimatedWeight: number) {
    this.weightFromBookShipment.next(estimatedWeight);
  }

  getEstimatedWeightFromBookShipment() {
    return this.estimatedWeight;
  }

  setEstimatedCubicFromBookShipment(estimatedCubic: number) {
    this.cubicFromBookShipment.next(estimatedCubic);
  }

  getEstimatedCubicFromBookShipment() {
    return this.estimatedCubic;
  }

  setSroIDFromBookShipment(sroID: string) {
    this.sroIDFromBookShipment.next(sroID);
  }

  getSroIDFromBookShipment() {
    return this.sroID;
  }

  setFleetVehiclesFromBookShipment(noOfFleetVehicles: number) {
    this.fleetVehiclesFromBookShipment.next(noOfFleetVehicles);
  }

  getFleetVehiclesFromBookShipment() {
    return this.noOfFleetVehicles;
  }

  setVehicleTypeFromBookShipment(fleetVehicleClass: string) {
    this.vehicleTypeFromBookShipment.next(fleetVehicleClass);
  }

  getVehicleTypeFromBookShipment() {
    return this.fleetVehicleClass;
  }
}
